import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";

// キャメルケースをスネークケースに変換する関数
const toSnakeCase = (obj: any): any => {
  if (obj === undefined || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((v) => toSnakeCase(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
      acc[snakeKey] = toSnakeCase(obj[key]);
      return acc;
    }, {} as any);
  }
  return obj;
};

const getClient = (): AxiosInstance => {
  const client: AxiosInstance = axios.create({
    baseURL: "/api/v1",
  });

  // リクエストインターセプターでキャメルケースをスネークケースに変換
  client.interceptors.request.use((config) => {
    if (config.data) {
      config.data = toSnakeCase(config.data);
    }
    return config;
  });

  const onSuccess = (response: AxiosResponse) => {
    return response;
  };
  const onError = (err: AxiosError) => {
    console.log("AxiosError@client", err);
    if (err.response) {
      const data = err.response.data as { errors?: string[] | string };
      if (Array.isArray(data.errors)) {
        const messages: string[] = data.errors;
        console.log("messages", messages);
      } else if (typeof data.errors === "string") {
        console.log("message", data.errors);
      } else if (err.response.status === 422) {
        console.log(
          "入力エラー: 入力内容に誤りがあります。再度確認してください。"
        );
      } else {
        console.log("エラー: エラーが発生しました。お問い合わせください");
      }
    }
    return Promise.reject(err);
  };

  client.interceptors.response.use(onSuccess);

  client.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") || "",
  };

  return client;
};

export const getRootClient = (): AxiosInstance => {
  const client: AxiosInstance = axios.create({
    baseURL: "/",
  });

  const onSuccess = (response: AxiosResponse) => response;

  const onError = (err: AxiosError) => {
    return Promise.reject(err);
  };

  client.interceptors.response.use(onSuccess, onError);

  client.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") || "",
  };

  return client;
};

export { getClient };
export default getClient;
